import { gql } from '@apollo/client';

export const fetchTXAPartnerAccount = gql`
  query fetchTXAPartnerAccount($id: ID!) {
    txaPartnerAccount(id: $id) {
      programLevelGlobal
      type
      territory
      sourceSystem
      sourceId
      domains {
        main
        alternates
      }
      verifiedExpertise
      payOnAccount
      specializations
    }
  }
`;
